import { ApplicationConfig, APP_INITIALIZER, inject } from '@angular/core';
import { provideRouter, withHashLocation, withEnabledBlockingInitialNavigation, withInMemoryScrolling, RouteReuseStrategy } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { authInterceptor } from './interceptors/auth.interceptor';
import { CustomRouteReuseStrategy } from './route-reuse.strategy';
import { SessionTimeoutService } from './services/session-timeout';

export function initSessionTimeout() {
  const sessionService = inject(SessionTimeoutService);
  return () => {
    // Service initialized dynamically based on auth state effect
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideRouter(
      routes,
      withHashLocation(),
      // Finish the first navigation (incl. guards) before showing the app — avoids login flash.
      withEnabledBlockingInitialNavigation(),
      // Old PE: new view starts at top; default router keeps scroll position between routes.
      withInMemoryScrolling({ scrollPositionRestoration: 'top' })
    ),
    provideClientHydration(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    {
      provide: APP_INITIALIZER,
      useFactory: initSessionTimeout,
      multi: true
    }
  ]
};
